import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, CssBaseline, Toolbar } from '@mui/material';
import AdminAppBar from './AdminAppBar';

/**
 * Adminschermen zonder seizoen-sidebar: het seizoenenoverzicht en het
 * beheerdersscherm. Beide staan boven de seizoenen, niet erin.
 */
function AdminShell() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <CssBaseline />
            <AdminAppBar />
            <Box component="main" sx={{ flexGrow: 1, width: '100%' }}>
                <Toolbar />
                <Container maxWidth="lg" sx={{ pt: 4, pb: 6 }}>
                    <Outlet />
                </Container>
            </Box>
        </Box>
    );
}

export default AdminShell;
